import { RootInitialState } from '@packages/shared/core/common/store/rootReducer';
import { getIsTestingEnv, getSystemPlatform } from '@packages/shared/core/common/store/system';
import { getGender, getUserFunnel, getUtmSource, getUtmAdName } from '@packages/shared/core/user/store/selectors';
import { getUserCountry } from '@packages/shared/core/location/store/selectors';
import { FeatureFlagsAttributes } from '../entities';

export const getFeatureFlagsAttributes = (state: RootInitialState): FeatureFlagsAttributes => {
  const gender = getGender(state);
  const isTestingEnv = getIsTestingEnv(state);
  const platform = getSystemPlatform(state);
  const utmSource = getUtmSource(state);
  const utmAdName = getUtmAdName(state);
  const funnel = getUserFunnel(state);
  const country = getUserCountry(state);

  return {
    gender,
    isTestingEnv,
    utmSource,
    platform,
    funnel,
    locale: country,
    utmAdName,
  };
};
